import BaseScenarioPart from "../../../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { getNextPartId } from "../../../../misc/tools";
import { BaseGeneralConfig, GameBaseScenario, GeneralPartConfig } from "../../../GameBaseScenario";
import NonAffiliatedStudentsComponentsStep1Part1 from "./non-affiliated-students-components-step1-parts/non-affiliated-students-components-step1-part1";

export default class NonAffiliatedStudentsComponentsStep1Component {
	private _parts: BaseScenarioPart<GameBaseScenario>[] = [];
	private _partId1 = getNextPartId();
	public get parts() {
		return this._parts;
	}
	constructor(public config: NonAffiliatedStudentsComponentsStep1ComponentMainConfig) {
		let context = this;
		context._parts.push(new NonAffiliatedStudentsComponentsStep1Part1(context.config.scenario, () => {
			config.onDone();
		}, context._partId1, config));
	}

	public start() {
		this.goToPart1();
	}

	goToPart1() {
		this.config.scenario.loadPart(this._partId1);
	}
}

export interface NonAffiliatedStudentsComponentsStep1ComponentMainConfig extends BaseGeneralConfig {
	scenario: GameBaseScenario;
	part1Config?: NonAffiliatedStudentsComponentsStep1ComponentPart1Config;
	onDone: () => void;
}

export interface NonAffiliatedStudentsComponentsStep1ComponentPart1Config extends GeneralPartConfig {
	chapter: () => string;
}